import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.talktokam.com',
  withCredentials: true,
});

export default client;
